<template>
  <BaseModal ref="baseModalRef" v-bind="childProps">
    <template v-slot:body>
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="수신자">
                <template #end="{id}">
                  <div class="input-group mb-3">
                    <ElInput :id="id" v-model="state.emailParams.receiver_nms" :disabled="true"/>
                    <ElButton type="s-search" @buttonClick="openUserSearch()"></ElButton>
                    <ElButton type="trashCan" @buttonClick="clearUsers()"></ElButton>
                  </div>
                </template>
              
              </ElLabel>
              
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="제목">
                  <template #end="{id}">
                    <ElInput :id="id" v-model="state.emailParams.title"/>
                  </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="내용"/>
              <div class="card">
                <Editor v-if="state.emailParams.content" v-model="state.emailParams.content" editorStyle="height: 320px" :key="editorKey"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  
  </BaseModal>
    <!-- 사용자 검색 모달 (1.컴포넌트) -->
    <UserSearchModal v-if="state.isopen" ref="userSearchModalRef" @return="(users) => (userSearchCallback(users))"/>
</template>

<script setup>
import { reactive,ref } from 'vue';
import Editor          from 'primevue/editor';
import BaseModal from '@/components/common/modal/BaseModal.vue';
import UserSearchModal from './UserSearchModal.vue';
import { useUserStore } from '@/store/user';
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { send } from '@/api/email';


/** 사용자 검색 모달 (2.컴포넌트 import 및 참조 선언) */
const userSearchModalRef = ref();
const baseModalRef = ref()

const state = reactive({
  emailParams : {
    sender_id : sessionStorage.getItem('userId'),
    title : '',
    content : '',
    call_prgm_id : '',
    call_prgm_nm : '',
    receiver_ids : '',
    receiver_nms : '',
    content2:null
  },
  isopen:false,
})
const editorKey = ref(0)
const childProps = ref({
  modalId : 'email',
  modalNm : '메일발송',
  size: 'lg',
  btnList:[
    {name : '발송', classNm : 'modelFooterConfirm', function:sendMail},
  ]
})

//메일발송 modal열기
function openEmailModal(object){
  //메일 정보의 초기화
  Object.assign(state.emailParams,object)
  if(state.emailParams.call_prgm_id =='MRD_DS_002'){

  }
  editorKey.value += 1
  baseModalRef.value.openModal()
  state.isopen=true
}


//메일발송 modal 닫기
function closeEmailModal(){
  baseModalRef.value.closeModal()
  state.isopen=false
}


/** 메일발송 처리 */
async function sendMail(){
  const isValid = validate();
  if(!isValid) {
    return;
  }

  const isConfirmed = confirm(`메일을 발송 하시겠습니까?`);
  if(isConfirmed) {
    try {
    setIsLoading(true)
      const res = await send(state.emailParams)
      alert(`메일이 발송되었습니다.`);
    } catch (err) {
      alert(`메일 발송에 실패하였습니다. [${err.code}] ${err.message}`);
    } finally {
      setIsLoading(false)
      closeEmailModal()
    }
  }
};

/** 입력값 유효성 체크 */
function validate(){
  if(state.emailParams.receiver_ids.trim() == '') {
    alert('수신자 항목은 필수 입력값입니다.');
    return false;
  } else if(state.emailParams.title.trim() == '') {
    alert('제목 항목은 필수 입력값입니다.');
      return false;
  }
  return true;
}

/** 수신자 초기화 */
function clearUsers(){
  state.emailParams.receiver_ids = '';
  state.emailParams.receiver_nms = '';
}

/** 수신자 검색 */
function openUserSearch(){
  userSearchModalRef.value.openUserModal(true); /** 사용자 검색 모달 (3.팝업열기) */
};

/** 수신자 검색 콜백 */
function userSearchCallback(users){ /** 사용자 검색 모달 (4.콜백함수) */
  const user_ids = users.map(user => user.user_id);
  const user_nms = users.map(user => user.user_nm);

  state.emailParams.receiver_ids = user_ids.join(',');
  state.emailParams.receiver_nms = user_nms.join(', ');
};



defineExpose({
    openEmailModal
});

</script>